import React from "react";
import { Avatar, IconButton, Menu, MenuItem, Typography, Divider } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import axios from "axios";

class UserMenu extends React.Component {
  state = { anchorEl: null };

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };


  handleLogout = () => {
    axios.post("/api/user/logout/")
      .then(() => {
        // clear any frontend state if needed
        window.location.href = "/"; // back to sign-in page
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  };

  render() {
    const { anchorEl } = this.state;
    const { user, onLogout } = this.props; // pass user + logout handler via props
    const displayCompanyName =
      String(user?.company || "").trim().toLowerCase() === "butlins"
        ? "Butlin's"
        : (user?.company || "");

    return (
      <>
        <IconButton onClick={this.handleMenuOpen} size="small">
          <Avatar
            sx={{
              width: 42,
              height: 42,
              bgcolor: "#0497b2", // MUI theme blue
              fontWeight: "bold",
              fontSize: 14,
            }}
          >
            {user.name
              ? user.name
                  .split(" ")
                  .map((part) => part[0].toUpperCase())
                  .slice(0, 2)
                  .join("")
              : "U"}
          </Avatar>
        </IconButton>


        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleMenuClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem disabled>
            <div>
              <Typography variant="subtitle1" fontWeight="bold">
                {user.name || "User"}
              </Typography>
              <Typography variant="body2">{displayCompanyName}</Typography>
            </div>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              this.handleMenuClose();
              this.handleLogout(); // call logout function passed in
            }}
          >
            <LogoutIcon fontSize="small" style={{ marginRight: 8 }} />
            Logout
          </MenuItem>
        </Menu>
      </>
    );
  }
}

export default UserMenu;
